/**
 * The Brazilian CPF, as the backend's ValidCpf checks it: eleven digits, the last two check digits
 * over the first nine, and not one digit repeated (those pass the arithmetic but are never issued).
 */
export const cpfDigits = (value: string | null | undefined): string => (value ?? '').replace(/\D/g, '');

export function isValidCpf(value: string | null | undefined): boolean {
  const digits = cpfDigits(value);

  if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) {
    return false;
  }

  return [9, 10].every((length) => {
    const sum = digits
      .slice(0, length)
      .split('')
      .reduce((total, digit, index) => total + Number(digit) * (length + 1 - index), 0);

    return ((sum * 10) % 11) % 10 === Number(digits[length]);
  });
}

/** 529.982.247-25 while typing; anything past eleven digits is dropped. */
export function formatCpf(value: string): string {
  const digits = cpfDigits(value).slice(0, 11);

  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
}
